import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';
import SchemaEditor from '../../../components/form/schema-editor';
import { useNodeContext } from '../../../context/node-context';

const AmazonRDSWriterForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id } = node;
  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="amazonRDSWriterFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={form.formState.errors.name?.message}
      />
      <FormField
        controlId="amazonRDSWriterFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={form.formState.errors.type?.message}
      />
      <FormField
        controlId="amazonRDSWriterFormDelayedRead"
        label="delayedRead"
        name="delayedRead"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="amazonRDSWriterFormOnError"
        label="onError"
        name="onError"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SELECT}
        error={errors?.onError?.message}
      >
        <option value="">Select On Error</option>

        <option value="continue">Continue</option>
        <option value="stop">Stop</option>
      </FormField>

      <FormField
        controlId="amazonRDSWriterFormConnectionKey"
        label="connectionKey"
        name="connectionKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.connectionKey?.message}
      />
      <FormField
        controlId="amazonRDSWriterFormDatabaseType"
        label="databaseType"
        name="properties.databaseType"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        required
        error={form.formState.errors.properties?.databaseType?.message}
      />
      <FormField
        controlId="amazonRDSWriterFormDatabaseName"
        label="databaseName"
        name="properties.databaseName"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter database name"
        required
        error={form.formState.errors.properties?.databaseName?.message}
      />
      <FormField
        controlId="amazonRDSWriterFormTableName"
        label="tableName"
        name="properties.tableName"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter table name"
        required
        error={errors.properties?.tableName?.message}
      />
      <FormField
        controlId="amazonRDSWriterFormDriver"
        label="driver"
        name="properties.driver"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter driver"
        required
        error={errors.properties?.driver?.message}
      />
      <FormField
        controlId="amazonRDSWriterFormHost"
        label="host"
        name="properties.host"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter host"
        error={errors.properties?.host?.message}
      />
      <FormField
        controlId="amazonRDSWriterFormPort"
        label="port"
        name="properties.port"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter port"
        type="number"
        error={errors.properties?.port?.message}
      />
      <FormField
        controlId="amazonRDSWriterFormInstanceConnectionName"
        label="instanceConnectionName"
        name="properties.instanceConnectionName"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.properties?.instanceConnectionName?.message}
      />
      <FormField
        controlId="amazonRDSWriterFormUsername"
        label="username"
        name="properties.username"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter username"
        error={errors?.properties?.username?.message}
      />
      <FormField
        controlId="amazonRDSWriterFormPassword"
        label="password"
        name="properties.password"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        type="password"
        placeholder="Enter password"
        error={errors?.properties?.password?.message}
      />
      <SchemaEditor form={form} id={id} />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default AmazonRDSWriterForm;
